export const realEstateNavItems = {
  services: 'Serveis',
  landPlot: 'Terreny',
};

export const realEstateSecondDescription =
  `El nostre objectiu és ajudar-lo a trobar la casa dels seus somnis, tant si desitja comprar com llogar. Oferim una àmplia gamma de propietats en diferents ubicacions i estils, per la qual cosa segur que trobarà alguna cosa que s'adapti a les seves necessitats i pressupost. Una ullada a les nostres propietats destacades a continuació o utilitzi la barra de recerca per trobar un tipus específic de propietat o ubicació. Si necessita ajuda o té alguna pregunta, no dubti a posar-se en contacte amb nosaltres.`;
